<template>
  <div
    class="bg-white relative rounded-2xl border grid gap-2 pb-2 shadow-md overflow-hidden"
  >
    <Top :data="data" :isCollection="isCollection" />
    <!-- <Story :class="{ lock: data.is_fake }" :data="data" v-if="data.placement" /> -->
    <Post
      :class="{ lock: data.is_fake }"
      :data="data"
      :isCollection="isCollection"
    />
    <Bottom :data="data" />
  </div>
</template>

<script>
import Post from "./Post";
// import Story from "./Story";
import Top from "./Top";
import Bottom from "./Bottom";

export default {
  components: {
    Post,
    Top,
    Bottom,
    // Story
  },
  props: {
    data: Object,
    isCollection: Boolean,
    unlock: Boolean,
  },
};
</script>

<style>
.lock {
  filter: blur(12px);
  pointer-events: none;
}
</style>
